import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { UPDATE_FE_CATEGORY_PAGE_CACHING_250409 } from "@faire/web-api--source/indigofair/settings/UPDATE_FE_CATEGORY_PAGE_CACHING_250409";

export const useSettingFilteredComponents30sec = (): boolean => {
  return useSetting(UPDATE_FE_CATEGORY_PAGE_CACHING_250409, false);
};
export const useAssignSettingFilteredComponents30sec = () =>
  useAssignSetting(UPDATE_FE_CATEGORY_PAGE_CACHING_250409);
